import React from "react";
import ReactCountryFlag from "react-country-flag";
import styled from "styled-components";
import { countries, CountryCode } from "@domain/currentProfile/countryCode";

interface ProfileLocationProps extends React.HTMLAttributes<HTMLDivElement> {
	countryCode: CountryCode;
}

export const CountryFlag: React.FC<ProfileLocationProps> = ({ countryCode }) => {
	return (
		<ContainerFlag>
			<ReactCountryFlag
				className="emojiFlag"
				countryCode={countryCode}
				style={{
					fontSize: 20,
				}}
				aria-label={countries[countryCode]}
			/>
		</ContainerFlag>
	);
};

const ContainerFlag = styled.div`
	margin-right: 8px;
`;
